import findingService from '../routes/finding/v2-service.js';
import { is_domain_list, is_hostname_list, is_ip_list } from '../routes/asset/assets.api.js';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { isJson, ipAdressesCustomComparator } from '../js/utils.js';
import markdownit from 'markdown-it';
import { format, locale } from 'svelte-i18n';
import { get as getStore } from 'svelte/store';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export function getTableTranslations() {
    let readLocale = getStore(locale);
    locale.set(readLocale)
    return {
        add: getStore(format)("list.interface.add"),
        delete: getStore(format)("list.interface.delete"),
        filterBy: getStore(format)("list.interface.filterBy"),
        from: getStore(format)("list.interface.from"),
        invertSelection: getStore(format)("list.interface.invertSelection"),
        next: getStore(format)("list.interface.next"),
        of: getStore(format)("list.interface.of"),
        previous: getStore(format)("list.interface.previous"),
        rows: getStore(format)("list.interface.rows"),
        search: getStore(format)("list.interface.search"),
        selectAll: getStore(format)("list.interface.selectAll"),
        selectNone: getStore(format)("list.interface.selectNone"),
    }
}

export function getAssetsColumnsDefinition(kind) {
    if (!kind) return;

    let cols = [];

    let extraCols = { properties: [], relations: [], relatedAssetsKind: [] };
    if (kind != 'all') {
        cols.push({ key: 'select', title: "", filterable: false, sortable: false });
    }

    cols.push(
        { key: 'name', title: "Nombre", filterable: false, parseAs: 'unsafe-html' },
        { key: 'description', title: "Descripción", parseAs: 'unsafe-html', filterable: false }
    );

    if (is_ip_list(kind)) {
        extraCols.properties.push(
            { key: 'port_status', title: "Puertos", filterable: false },
            { key: 'os', title: "SO", filterable: false, parseAs: 'unsafe-html' },
        );
        if (is_ip_list(kind, true).public) {
            extraCols.properties.push(
                { key: 'location', title: "País", filterable: false, parseAs: 'unsafe-html' },
            );
            extraCols.relations.push({ key: 'rels', title: "Hostnames", filterable: false, parseAs: 'unsafe-html' });
            extraCols.relatedAssetsKind.push("hostname");
        }
        if (is_ip_list(kind, true).private) {
            extraCols.properties.push(
                { key: 'netbios', title: "Hostname", filterable: false },
            );
        }
    }

    if (is_hostname_list(kind)) {
        extraCols.relations.push({ key: 'rels', title: "IPs", filterable: false, parseAs: 'unsafe-html' });
        extraCols.relatedAssetsKind.push("public_ip", "private_ip");
    }

    if (kind.includes("domain")) {
        extraCols.properties.push({ key: 'valid_until', title: "Válido hasta", filterable: false, parseAs: 'unsafe-html' });
        extraCols.properties.push({ key: 'expiration_date', title: "Expira en", filterable: false, parseAs: 'unsafe-html' });
    }

    if (!is_hostname_list(kind) && !kind.includes('network')) {
        cols.push({ key: 'finding_count', title: "Hallazgos", parseAs: 'unsafe-html', filterable: false, parseAs: 'unsafe-html' },)
    }

    cols.push(
        { key: 'first_discovery_at', title: "Creado", filterable: false, parseAs: 'unsafe-html' },
        { key: 'last_discovery_at', title: "Visto", filterable: false, parseAs: 'unsafe-html' },
        { key: 'in_scope', title: 'En alcance', filterable: false, parseAs: 'unsafe-html' },
        { key: 'tag', title: "Etiquetas", filterable: false, parseAs: 'unsafe-html' }
    );

    if (kind === 'all') cols.push({ key: 'kind', title: "Tipo de Activo", filterable: false })

    return {
        columns: cols,
        extraColumns: extraCols
    };
}

export function orderByDate(data) {
    function handleNulls(a, b) {
        if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
            if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
                return 0;
            }
            else if (!a && a !== 0 && a !== false) {
                return -1;
            }
            else if (!b && b !== 0 && b !== false) {
                return 1;
            }
        }
        return null;
    };

    return data = data.sort((a, b) => {
        if (a.cert_expires === '') a.cert_expires = null;
        if (b.cert_expires === '') b.cert_expires = null;

        let nulls = handleNulls(a, b);
        if (nulls !== null) {
            return nulls;
        }
        else {
            if (!(a.cert_expires instanceof Date)) {
                a.cert_expires = new Date(a.cert_expires);
            }
            if (!(b.cert_expires instanceof Date)) {
                b.cert_expires = new Date(b.cert_expires);
            }
            let timeA = a.cert_expires.getTime()
            let timeB = b.cert_expires.getTime();

            return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
        }
    })
}

export function sortNumbers(v1, v2) {
    if (v1 === '' || v1 === '-' || parseFloat(v1) == NaN) v1 = -1;
    if (v2 === '' || v2 === '-' || parseFloat(v2) == NaN) v2 = -1;
    return parseFloat(v1) < parseFloat(v2) ? -1 : parseFloat(v1) > parseFloat(v2) ? 1 : 0;
}

export function sortFindings(v1, v2) {
    if (isJson(v1) && isJson(v2)) {
        v1 = JSON.parse(v1);
        v2 = JSON.parse(v2);
        return (v1.critical.open + v1.critical.accepted < v2.critical.open + v2.critical.accepted ? 1 : v1.critical.open + v1.critical.accepted > v2.critical.open + v2.critical.accepted ? -1 : 0) || ((v1.high.open + v1.high.accepted < v2.high.open + v2.high.accepted ? 1 : v1.high.open + v1.high.accepted > v2.high.open + v2.high.accepted ? -1 : 0)) || (v1.medium.open + v1.medium.accepted < v2.medium.open + v2.medium.accepted ? 1 : v1.medium.open + v1.medium.accepted > v2.medium.open + v2.medium.accepted ? -1 : 0) || (v1.low.open + v1.low.accepted < v2.low.open + v2.low.accepted ? 1 : v1.low.open + v1.low.accepted > v2.low.open + v2.low.accepted ? -1 : 0);
    }
    else {
        return;
    }
}
export function ipsColCustomSort(a, b) {
    let v1;
    let v2;
    if (isJson(a) && isJson(b)) {
        a = JSON.parse(a);
        b = JSON.parse(b);

        v1 = a[0] ? a[0].name : '';
        v2 = b[0] ? b[0].name : '';
    }
    else {
        return;
    }
    return ipAdressesCustomComparator(v1, v2);
}
export function sortDates(a, b) {
    function handleNulls(val) {
        // Returns true if the value is essentially "empty" for date sorting purposes
        return !val && val !== 0 && val !== false;
    }

    let aIsNull = handleNulls(a);
    let bIsNull = handleNulls(b);

    if (aIsNull && bIsNull) return 0;
    if (aIsNull) return -1; // Push nulls/empty to the top (change to 1 for bottom)
    if (bIsNull) return 1;

    // Direct alphabetical string comparison (perfect for ISO 8601 strings)
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}

//@TODO: combine parse assets with parse tags
export function parseAssetsRow(input, rowIdx) {
    const md = new window.markdownit({ html: false });
    let assets = JSON.parse(input);
    let output;
    let values = [];
    for (let item of assets) {
        if (item) {
            if (item.name) item.name = md.render(item.name);
            if (item.nickname) item.nickname = md.render(item.nickname);
        }
        if (item) values.push(item);
    }
    if (values.length) {
        if (values.length == 1) {
            output = `<div>${values[0].nickname || values[0].name}</div>`;
        }
        else {
            output = `<div id="assets-visible-${rowIdx}" class="is-visible"><div>${values[0].nickname || values[0].name}</div>` +
                `<div id="showButton" style="width: 24px; cursor: pointer;" onclick="showContent('assets', ${rowIdx})">` +
                '<i class="fas fa-chevron-up chevron-button chevron-animation"></i>'
                + '</div></div>';

            for (let [index, item] of values.entries()) {
                if (index == 0) {
                    output = output + `<div id="assets-hidden-${rowIdx}" class="is-hidden">${item.name}`;
                }
                if (index > 0 && index < values.length - 1) {
                    output = output + `<div>${item.nickname || item.name}</div>`
                }

                if (index == values.length - 1) {
                    output = output + `<div >${item.nickname || item.name}</div>` +
                        `<div id="hideButton" style="width: 24px; cursor: pointer;" onclick="hideContent('assets', ${rowIdx})">` +
                        '<i class="fas fa-chevron-down chevron-button chevron-animation"></i>'
                        + '</div></div>';
                }
            }
        }
    }
    return output;
}

//@TODO: combine parse assets with parse tags
export function parseVulnerabilitiesRow(input, rowIdx) {
    const md = new window.markdownit({ html: false });
    let vulnerabilities = JSON.parse(input);
    let output;
    let values = [];
    for (let item of vulnerabilities) {
        if (item) {
            if (item.title_es) item.title_es = md.render(item.title_es);
            if (item.title) item.title = md.render(item.title);
        }
        if (item) values.push(item);
    }
    if (values.length) {
        if (values.length == 1) {
            output = `<div>${values[0].title_es || values[0].title}</div>`;
        }
        else {
            output = `<div id="vulnerabilities-visible-${rowIdx}" class="is-visible"><div>${values[0].title_es || values[0].title}</div>` +
                `<div id="showButton" style="width: 24px; cursor: pointer;" onclick="showContent('vulnerabilities', ${rowIdx})">` +
                '<i class="fas fa-chevron-up chevron-button chevron-animation"></i>'
                + '</div></div>';

            for (let [index, item] of values.entries()) {
                if (index == 0) {
                    output = output + `<div id="vulnerabilities-hidden-${rowIdx}" class="is-hidden">${item.title_es || item.title}`;
                }
                if (index > 0 && index < values.length - 1) {
                    output = output + `<div>${item.title_es || item.title}</div>`
                }

                if (index == values.length - 1) {
                    output = output + `<div >${item.title_es || item.title}</div>` +
                        `<div id="hideButton" style="width: 24px; cursor: pointer;" onclick="hideContent('vulnerabilities', ${rowIdx})">` +
                        '<i class="fas fa-chevron-down chevron-button chevron-animation"></i>'
                        + '</div></div>';
                }
            }
        }
    }
    return output;
}

//@TODO: combine parse assets with parse tags
export function parseFindingsRow(input, rowIdx) {
    const md = new window.markdownit({ html: false });
    let findings = JSON.parse(input);
    let output;
    let values = [];
    for (let item of findings) {
        if (item) {
            if (item.name) item.name = md.render(item.name);
        }
        if (item) values.push(item);
    }
    if (values.length) {
        if (values.length == 1) {
            output = `<div>${values[0].name}</div>`;
        }
        else {
            output = `<div id="findings-visible-${rowIdx}" class="is-visible"><div>${values[0].name}</div>` +
                `<div id="showButton" style="width: 24px; cursor: pointer;" onclick="showContent('findings', ${rowIdx})">` +
                '<i class="fas fa-chevron-up chevron-button chevron-animation"></i>'
                + '</div></div>';

            for (let [index, item] of values.entries()) {
                if (index == 0) {
                    output = output + `<div id="findings-hidden-${rowIdx}" class="is-hidden">${item.name}`;
                }
                if (index > 0 && index < values.length - 1) {
                    output = output + `<div>${item.name}</div>`
                }

                if (index == values.length - 1) {
                    output = output + `<div >${item.name}</div>` +
                        `<div id="hideButton" style="width: 24px; cursor: pointer;" onclick="hideContent('findings', ${rowIdx})">` +
                        '<i class="fas fa-chevron-down chevron-button chevron-animation"></i>'
                        + '</div></div>';
                }
            }
        }
    }
    return output;
}

export function parseTagsRow(input, rowIdx) {
    const md = new window.markdownit({ html: false });
    let tags = JSON.parse(input);
    let output;
    let values = [];
    for (let item of tags) {
        if (item) {
            if (item.name) item.name = md.render(item.name);
        }
        values.push(item);
    }
    if (values.length) {
        if (values.length == 1) {
            output = `<div><a href="/tag/${values[0].id}">${values[0].nickname || values[0].name}</a></div>`;
        }
        else {
            output = `<div id="tags-visible-${rowIdx}" class="is-visible"><div><a href="/tag/${values[0].id}">${values[0].nickname || values[0].name}</a></div>` +
                `<div id="showButton" style="width: 24px; cursor: pointer;" onclick="showContent('tags', ${rowIdx})">` +
                '<i class="fas fa-chevron-up chevron-button chevron-animation"></i>'
                + '</div></div>';

            for (let [index, item] of values.entries()) {
                if (index == 0) {
                    output = output + `<div id="tags-hidden-${rowIdx}" class="is-hidden"><a href="/tag/${item.id}">${item.name}</a>`;
                }
                if (index > 0 && index < values.length - 1) {
                    output = output + `<div><a href="/tag/${item.id}">${item.nickname || item.name}</a></div>`
                }

                if (index == values.length - 1) {
                    output = output + `<div><a href="/tag/${item.id}">${item.nickname || item.name}</a></div>` +
                        `<div id="hideButton" style="width: 24px; cursor: pointer;" onclick="hideContent('tags', ${rowIdx})">` +
                        '<i class="fas fa-chevron-down chevron-button chevron-animation"></i>'
                        + '</div></div>';
                }
            }
        }
    }
    return output;
}

export function parseFindingCountRow(row) {
    let output;
    let totals_by_status;
    if (typeof row.finding_count == "string") {
        totals_by_status = JSON.parse(row["finding_count"])
    }
    else {
        totals_by_status = row.finding_count;
    }
    let totals = {
        critical: totals_by_status.critical.open + totals_by_status.critical.accepted,
        high: totals_by_status.high.open + totals_by_status.high.accepted,
        medium: totals_by_status.medium.open + totals_by_status.medium.accepted,
        low: totals_by_status.low.open + totals_by_status.low.accepted,
    }
    for (let [name, total] of Object.entries(totals)) {
        if (name == "critical" && total > 0) {
            output = `<div class="cvss-badge cvss-badge-small cvss-${name}" title="${findingService.labels[name]}">${total}</div> `
        }
        if (name == 'critical' && total <= 0) {
            output = `<div class="cvss-badge cvss-badge-small cvss-zero" title="${findingService.labels[name]}">0</div> `
        }
        if (name == "high" && (total > 0 || totals["critical"] > 0)) {
            output = output + `<div class="cvss-badge cvss-badge-small cvss-${name}" title="${findingService.labels[name]}">${total}</div> `
        }
        if (name == 'high' && (total <= 0 && totals["critical"] <= 0)) {
            output = output + `<div class="cvss-badge cvss-badge-small cvss-zero" title="${findingService.labels[name]}">0</div> `
        }
        if (name == "medium" && (total > 0 || (totals["high"] > 0 || totals["critical"] > 0))) {
            output = output + `<div class="cvss-badge cvss-badge-small cvss-${name}" title="${findingService.labels[name]}">${total}</div> `
        }
        if (name == 'medium' && (total <= 0 && (totals["high"] <= 0 && totals["critical"] <= 0))) {
            output = output + `<div class="cvss-badge cvss-badge-small cvss-zero" title="${findingService.labels[name]}">0</div> `
        }
        if (name == "low" && (total > 0 || totals["medium"] > 0 || totals["high"] > 0 || totals["critical"] > 0)) {
            output = output + `<div class="cvss-badge cvss-badge-small cvss-${name}" title="${findingService.labels[name]}">${total}</div> `
        }
        if (name == 'low' && (total <= 0 && (totals["medium"] <= 0 && (totals["high"] <= 0 && totals["critical"] <= 0)))) {
            output = output + `<div class="cvss-badge cvss-badge-small cvss-zero" style="margin-right: 2em;" title="${findingService.labels[name]}">0</div> `
        }

    }
    return output;
}

export function parsePropertiesRow(input, rowIdx, kind) {
    if (kind.includes("location")) return input;
    let output;
    if (input) {
        if (input.length <= 1) {
            output = `<div>${input[0][0]}${kind === 'port_status' ? '' : ': ' + input[0][1]}</div>`;
        }
        else {
            output = `<div id="props-visible-${rowIdx}" class="is-visible"><div>${input[0][0]}${kind === 'port_status' ? '' : ': ' + input[0][1]}</div>` +
                `<div style="width: 24px; cursor: pointer;" onclick="showContent('props', ${rowIdx})">` +
                '<i class="fas fa-chevron-up chevron-button chevron-animation"></i>'
                + '</div></div>';

            for (let [index, item] of input.entries()) {
                //@TODO: store variables of item as in parseRelations
                if (index == 0) {
                    output = output + `<div id="props-hidden-${rowIdx}" class="is-hidden">${item[0]}${kind === 'port_status' ? '' : ': ' + item[1]}`;
                }
                if (index > 0 && index < input.length - 1) {
                    output = output + `<div>${item[0]}${kind === 'port_status' ? '' : ': ' + item[1]}</div>`
                }

                if (index == input.length - 1) {
                    output = output + `<div >${item[0]}${kind === 'port_status' ? '' : ': ' + item[1]}</div>` +
                        `<div style="width: 24px; cursor: pointer;" onclick="hideContent('props', ${rowIdx})">` +
                        '<i class="fas fa-chevron-down chevron-button chevron-animation"></i>'
                        + '</div></div>';
                }
            }
        }
    }
    return output;
}


export function parseRelationsRow(input, rowIdx) {
    let output;
    let values;
    for (let item of input) {
        values = Object.entries(item.values ? item.values : item);
    }

    if (values) {
        if (values.length <= 1) {
            output = `<a href="/asset/${values[0][1].kind}/${values[0][1].id}">${values[0][0]}</a>`;
        }
        else {
            output = `<div id="rels-visible-${rowIdx}" class="is-visible"><a href="/asset/${values[0][1].kind}/${values[0][1].id}">${values[0][0]}</a>` +
                `<div id="showButton" style="width: 24px; cursor: pointer;" onclick="showContent('rels', ${rowIdx})">` +
                '<i class="fas fa-chevron-up chevron-button chevron-animation"></i>'
                + '</div></div>';

            for (let [index, item] of values.entries()) {
                let name = item[0];
                let id = item[1].id;
                let kind = item[1].kind;
                if (index == 0) {
                    output = output + `<div id="rels-hidden-${rowIdx}" class="is-hidden"><div><a href="/asset/${kind}/${id}">${name}</a></div>`;
                }
                if (index > 0 && index < values.length - 1) {
                    output = output + `<div><a href="/asset/${kind}/${id}">${name}</a></div>`
                }

                if (index == values.length - 1) {
                    output = output + `<div><a href="/asset/${kind}/${id}">${name}</a></div>` +
                        `<div id="hideButton" style="width: 24px; cursor: pointer;" onclick="hideContent('rels', ${rowIdx})">` +
                        '<i class="fas fa-chevron-down chevron-button chevron-animation"></i>'
                        + '</div></div>';
                }
            }
        }
    }
    return output;
}

export function parseArrayOfStrings(input, rowIdx, kind, route = false) {
    const md = new window.markdownit({ html: false });
    let output = route ? `<a href="${route}">` : "";
    for (let text of input) {
        text = md.render(text);
    }
    if (input) {
        if (input.length <= 1) {
            output = "<div>" + (route ? `<a href="${route}">${input[0]}</a></div>` : `${input[0]}</div>`);
        }
        else {
            output = `<div id="${kind}-visible-${rowIdx}" class="is-visible"><div>${route ? `<a href="${route}">${input[0]}</a>` : input[0]}</div>` +
                `<div style="width: 24px; cursor: pointer;" onclick="showContent('${kind}', ${rowIdx})">` +
                '<i class="fas fa-chevron-up chevron-button chevron-animation"></i>'
                + '</div></div>';

            for (let [index, item] of input.entries()) {
                //@TODO: store variables of item as in parseRelations
                if (index == 0) {
                    output = output + `<div id="${kind}-hidden-${rowIdx}" class="is-hidden">${route ? `<a href="${route}">${input[index]}` : input[index]}`;
                }
                if (index > 0 && index < input.length - 1) {
                    output = output + `<div>${input[index]}</div>`
                }

                if (index == input.length - 1) {
                    output = output + `<div>${route ? input[index] + "</a>" : input[index]}</div>` +
                        `<div style="width: 24px; cursor: pointer;" onclick="hideContent('${kind}', ${rowIdx})">` +
                        '<i class="fas fa-chevron-down chevron-button chevron-animation"></i>'
                        + '</div></div>';
                }
            }
        }
    }
    if (route) output = output + "</a>"
    return output;
}

export function selectRows(selected_rows, current, idx, prefix) {
    let rows = JSON.parse(JSON.stringify(selected_rows));
    let rowIdx = current.__PT_ID__;
    let row = getSelectionQuery(prefix, rowIdx);
    if (idx > -1) {
        rows = rows.filter(row => row.id != current.id);
        row.classList.remove('selected');
    }
    else {
        rows.push(current);
        row.classList.add('selected');
    }
    return rows;
}

export function getSelectionQuery(prefix, rowIdx) {
    return document.querySelector(`div[data-prefix='${prefix}'] div[data-name='pTable'] div[data-name='table-container'] table tbody tr[data-id='${rowIdx}']`);
}
// 1. Calculate the new array strictly using database IDs (No DOM logic here)
export function selectAll(current_selected, target_elements, action) {
    let new_selected = [...current_selected];
    const targetIds = new Set(target_elements.map(e => e.id));

    if (action === 'select') {
        const existingIds = new Set(new_selected.map(e => e.id));
        for (let el of target_elements) {
            if (!existingIds.has(el.id)) {
                new_selected.push(el);
            }
        }
    } else if (action === 'deselect') {
        new_selected = new_selected.filter(e => !targetIds.has(e.id));
    }

    return new_selected;
}

// 2. Sync the screen using your proven getSelectionQuery
export function syncVisibleDOM(selected_rows, prefix, pageData) {
    if (!pageData) return;

    // Create a Set of database IDs currently selected
    const selectedIds = new Set(selected_rows.map(r => r.id));

    for (let item of pageData) {
        // Fetch the row exactly how selectRows does it
        let row = getSelectionQuery(prefix, item.__PT_ID__);

        if (row) {
            if (selectedIds.has(item.id)) {
                row.classList.add('selected');
            } else {
                row.classList.remove('selected');
            }
        }
    }
}
export function deselectAll() {
    let rows = document.querySelectorAll('.selected');
    for (let row of rows) {
        row.classList.remove("selected");
    }
    return [];
}

export function toggleActionButtons(selected_rows) {
    let btns = document.getElementsByClassName("btn-disabled");
    for (let btn of btns) {
        if (selected_rows.length > 0 && btn.id != "snapshotsCompareBtn") {
            btn.removeAttribute("disabled");
        }
        else {
            btn.setAttribute("disabled", true)
        }
        if (selected_rows.length == 2 && (btn.id === 'snapshotsCompareBtn')) {
            btn.removeAttribute("disabled");
        }
        if (selected_rows.length >= 2 && (btn.id.includes('EditBtn') || btn.id === 'tagSettingsBtn')) {
            btn.setAttribute("disabled", true);
        }
    }
}



export default {
    getTableTranslations,
    getAssetsColumnsDefinition,
    orderByDate,
    sortNumbers,
    sortFindings,
    ipsColCustomSort,
    sortDates,
    parseAssetsRow,
    parseVulnerabilitiesRow,
    parseFindingsRow,
    parseTagsRow,
    parseFindingCountRow,
    parsePropertiesRow,
    parseRelationsRow,
    parseArrayOfStrings,
    selectRows,
    getSelectionQuery,
    selectAll,
    syncVisibleDOM,
    deselectAll,
    toggleActionButtons,
}
